import { render, staticRenderFns } from "./TermsConditions.vue?vue&type=template&id=e45dd450&scoped=true&"
import script from "./TermsConditions.vue?vue&type=script&lang=ts&"
export * from "./TermsConditions.vue?vue&type=script&lang=ts&"
import style0 from "./TermsConditions.vue?vue&type=style&index=0&id=e45dd450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45dd450",
  null
  
)

export default component.exports